/**
 * Volltextsuche – Search Modal (Phase 2)
 *
 * Opens a DaisyUI <dialog> modal when the user clicks the search trigger
 * in the header. Manages focus, keyboard behaviour and aria-expanded.
 */
export async function initSearchModal() {
    /** @type {HTMLDialogElement|null} */
    const modal = document.querySelector('#site-search-modal');
    if (!modal) return;

    /** @type {HTMLInputElement|null} */
    const input = modal.querySelector('#search-input');

    /** @type {HTMLButtonElement|null} */
    const closeBtn = modal.querySelector('.search-modal-close');

    /** @type {NodeListOf<HTMLButtonElement>} */
    const triggers = document.querySelectorAll('.search-trigger');
    if (!triggers.length) return;

    /** Track which trigger opened the modal so we can return focus */
    let activeTrigger = null;

    // ── Open ────────────────────────────────────────────────────────
    function openModal(trigger) {
        activeTrigger = trigger;
        modal.showModal();
        triggers.forEach((t) => t.setAttribute('aria-expanded', 'true'));

        // showModal() moves focus to the dialog itself first.
        // A short timeout ensures the browser has finished its internal
        // focus handling before we override it with the input field.
        setTimeout(() => {
            input?.focus();
            input?.select();
        }, 50);
    }

    // ── Close ───────────────────────────────────────────────────────
    function closeModal() {
        modal.close();
    }

    // After native close (Esc, backdrop-form, close button) clean up state
    modal.addEventListener('close', () => {
        triggers.forEach((t) => t.setAttribute('aria-expanded', 'false'));
        if (activeTrigger) {
            activeTrigger.focus();
            activeTrigger = null;
        }
    });

    // ── Trigger buttons ─────────────────────────────────────────────
    triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => openModal(trigger));
    });

    // ── Explicit close button inside modal ──────────────────────────
    closeBtn?.addEventListener('click', () => closeModal());
}
